import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { DateRecord } from "../../model/data/DateRecord";
import { TimespanRecord } from "../../model/data/TimespanRecord";
import { DateDisplayRecord } from "./DateDisplayRecord";

export const ItemDatesRecord = Record({
  latestStartDate: null,
  startDate: DateDisplayRecord(),
  duration: TimespanRecord(),
  preferredStartDate: DateRecord(),
  preferredDuration: TimespanRecord(),
  durationToEarliestEnd: null,
  hasOngoingDescendants: false,
  endDate: DateDisplayRecord(),
  preferredEndDate: DateDisplayRecord(),
  drawPreferredEndDate: DateRecord(),
  earliestEndDate: null
});

const data = {
  objects: {
    latestStartDate: "DateDisplayRecord",
    startDate: "DateDisplayRecord",
    preferredStartDate: `DateRecord`,
    endDate: "DateDisplayRecord",
    preferredEndDate: "DateRecord",
    drawPreferredEndDate: "DateRecord",
    duration: "TimespanRecord",
    preferredDuration: `TimespanRecord`,
    durationToEarliestEnd: "TimespanRecord"
  }
};
createFromJS.registerCallback("ItemDatesRecord", createFromJS.createNestedCallback(ItemDatesRecord, data));
